import { Fragment } from "react";
import { IconButton } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useKeywordAssist } from "../Providers/KAProviders";

function KAURLList() {

  const { state: { detailedViewURL, keywordsData }, setDetailedViewURL } = useKeywordAssist();

  const currentIndex = keywordsData?.page_details
    ? keywordsData.page_details.findIndex(
        (item) => item.page_url.toLowerCase() === detailedViewURL.toLowerCase()
      )
    : -1;
  const currentItem = currentIndex !== -1 ? keywordsData?.page_details[currentIndex] : null;

  const handlePrev = () => {
    if (currentIndex > 0 && keywordsData?.page_details) {
      setDetailedViewURL(keywordsData.page_details[currentIndex - 1].page_url);
    }
  };

  const handleNext = () => {
    if (
      keywordsData?.page_details &&
      currentIndex >= 0 &&
      currentIndex < keywordsData.page_details.length - 1
    ) {
      setDetailedViewURL(keywordsData.page_details[currentIndex + 1].page_url);
    }
  };

  const displayIndex = currentIndex !== -1 ? currentIndex + 1 : 1;
  const totalCount = keywordsData?.page_details?.length || 0;

  return (
    <Fragment>
      <div className="rounded-lg shadow-[0px_1px_8px_0px_var(--color-shadow-card)] py-4">
        <div className="px-6 flex justify-between items-center gap-3">
          <div className="flex items-center gap-3 flex-wrap">
            <div>
              <p className="inline-block text-[#475467] font-medium text-[16px] mr-4">
                Page Name
              </p>
              <p className="inline-block text-[#3b11b8] font-semibold text-[16px]">
                {detailedViewURL}
              </p>
            </div>
            {currentItem?.full_url && (
              <a
                href={currentItem.full_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-[#3b11b8] underline inline-flex items-center gap-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                  />
                </svg>
              </a>
            )}
          </div>
          <div className="flex items-center">
            <p className="text-primary text-base mr-4 font-semibold">{displayIndex} / {totalCount}</p>
            <IconButton
              onClick={handlePrev}
              disabled={currentIndex <= 0}
              size="small"
              sx={{ p: 1 }}
            >
              <ArrowBackIosNewIcon sx={{ fontSize: 16, color: currentIndex <= 0 ? '#CBD5E1' : 'var(--color-primary)' }} />
            </IconButton>
            <IconButton
              onClick={handleNext}
              disabled={currentIndex === -1 || currentIndex >= totalCount - 1}
              size="small"
              sx={{ p: 1 }}
            >
              <ArrowForwardIosIcon sx={{ fontSize: 16, color: (currentIndex === -1 || currentIndex >= totalCount - 1) ? '#CBD5E1' : 'var(--color-primary)' }} />
            </IconButton>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default KAURLList;